import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { UserService } from "../_services/user.service";
import { Observable } from "rxjs/Rx";

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private _router: Router, private _userService: UserService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        let currentUser = (localStorage.getItem('currentUser'));
        console.debug('Checking if Auth and canActivate Route Guard...');
        return Observable.fromPromise(this._userService.verify()).map(
            data => {
                if (data !== null) {
                    // logged in so return true
                    return true;
                }
                console.debug('USER SERVICE ' + data);
                // error when verify so redirect to login page with the return url
                this._router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
                return false;
            },
            error => {
                console.error('Error getting Authentication State!');
                console.error(error);
                // error when verify so redirect to login page with the return url
                this._router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
                return false;
            });
    }
}


// WEBPACK FOOTER //
// ./src/app/auth/_guards/auth.guard.ts